<template>
  <div class="border-1 google-maps fill-height">Google maps</div>
</template>

<script>
export default {}
</script>

<style></style>
